import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import PageTitle from "../base/PageTitle";
import Setup from "../views/Setup";
import { useSelector } from "../../store";
import { useNavigate } from "react-router-dom";

interface Props {}

const SetupPage: React.FC<Props> = (props) => {
  const navigate = useNavigate();
  const { addNewCompany, allowedCompanies, selectedCompany } = useSelector(
    (store) => store.company
  );
  const { appLoaded } = useSelector((store) => store.shared);

  useEffect(() => {
    if (!!selectedCompany?.finishedSetup) {
      navigate("/settings");
    }
  }, [selectedCompany?.finishedSetup, navigate]);

  return appLoaded.companyList &&
    (!selectedCompany?.finishedSetup ||
      !allowedCompanies.length ||
      addNewCompany) ? (
    <Box>
      <PageTitle title="Welcome to SVPRO!" />
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="center"
        alignContent="center"
        justifyItems="center"
        alignItems="center"
        paddingX={30}
        paddingBottom={5}
      >
        <Typography variant="h4" textAlign="center">
          SVPRO helps you streamline security operations with real-time
          alerting, seamless integrations, and data-driven insights. By setting
          up your company profile, you'll unlock access to all of our products,
          each designed to enhance efficiency and decision-making. Complete the
          information below to get started!
        </Typography>
      </Box>
      <Setup />
    </Box>
  ) : (
    <Box></Box>
  );
};

export default SetupPage;
